import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 2fr 1.5fr 1fr 1fr 1fr;
    gap: 24px;
    margin-top: 24px;
    padding: 0 24px;
    justify-items: start;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const HeaderCell = styled.div`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[40]};
    user-select: none;

    &:hover {
      color: ${theme.v3.colors.neutral[40]};
    }
  `}
`;

export const HeaderCellContent = styled.div`
  ${({ $clickable }) => css`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: ${$clickable ? 'pointer' : 'default'};

    svg {
      flex: 0 0 12px;
      width: 12px;
    }
  `}
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ListItem = styled.div`
  ${({ theme }) => css`
    justify-items: start;
    position: relative;
    display: grid;
    align-items: center;
    grid-template-columns: 2fr 1.5fr 1fr 1fr 1fr;
    gap: 24px;
    padding: 24px;
    border-radius: 16px;
    background-color: ${theme.v3.colors.neutral[100]};
    box-shadow: 0 2px 4px 0 ${theme.v3.colors.neutral[90]}24, 0 2px 4px 0 ${theme.v3.colors.neutral[90]}33;
    transition: all 0.2s ease;

    &:hover {
      box-shadow: 0 4px 8px 0 ${theme.v3.colors.neutral[90]}33, 0 2px 4px 0 ${theme.v3.colors.neutral[90]}40;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      grid-template-columns: 1fr;
    }
  `}
`;

export const ActionsGroup = styled.div`
  ${({ theme, align }) => css`
    width: 100%;
    min-width: 0;
    gap: 10px;

    display: flex;
    align-items: center;
    justify-content: ${align === 'right' ? 'flex-end' : 'flex-start'};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      align-items: flex-start;
      justify-content: space-between;
      gap: 4px;
    }
  `}
`;

export const Cell = styled.div`
  ${({ theme, align }) => css`
    width: 100%;
    min-width: 0;

    display: flex;
    align-items: center;
    justify-content: ${align === 'right' ? 'flex-end' : 'flex-start'};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      align-items: flex-start;
      justify-content: space-between;
      gap: 4px;
    }
  `}
`;

export const CellLabel = styled.p`
  ${({ theme }) => css`
    font-weight: ${theme.v3.font.weights.regular};
    font-size: 14px;
    line-height: 1.5;
    color: ${theme.v3.colors.neutral[60]};
    margin: 0 0 2px 0;
  `}
`;

export const CellContent = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const ServerName = styled.p`
  ${({ theme }) => css`
    line-height: 1.5;
    font-size: 16px;
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const ServerDomain = styled.p`
  ${({ theme }) => css`
    font-size: 14px;
    line-height: 1.5;
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[60]};
    margin: 0;
  `}
`;

export const ServerIp = styled.p`
  ${({ theme }) => css`
    font-size: 16px;
    line-height: 1.5;
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 32px;
    justify-content: flex-end;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      justify-content: flex-start;
    }
  `}
`;

export const IconButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 8px;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: ${theme.v3.colors.neutral[95]};
    }
  `}
`;

export const Favorite = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  cursor: pointer;
`;

export const ListItemAlertDanger = styled.div`
  ${({ theme }) => css`
    margin-top: -12px;

    display: grid;
    align-items: center;
    gap: 24px;

    padding: 25px 24px 15px;
    border-radius: 0 0 16px 16px;

    background-color: ${theme.v3.colors.brand.snappyOrange[95]};
    color: ${theme.v3.colors.brand.snappyOrange[20]};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;


export const ListItemAlertInfo = styled.div`
  ${({ theme }) => css`
    margin-top: -12px;

    display: grid;
    align-items: center;
    gap: 24px;

    padding: 25px 24px 15px;
    border-radius: 0 0 16px 16px;

    background: ${theme.v3.colors.brand.snappyBlue[95]};
    color: ${theme.v3.colors.brand.snappyBlue[20]};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const DangerLabel = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${theme.v3.colors.brand.snappyOrange[20]};
    font-weight: ${theme.v3.font.weights.medium};
    font-family: ${theme.v3.font.family.brand};
  `}
`;

export const AlertText = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-family: ${theme.v3.font.family.brand};
    font-weight: ${theme.v3.font.weights.medium};
  `}
`;

export const AlertLink = styled.button`
  ${({ theme }) => css`
    background: none;
    border: none;
    padding: 0;
    margin: 0;

    color: ${theme.v3.colors.brand.snappyBlue[50]};
    cursor: pointer;

    font-weight: ${theme.v3.font.weights.medium};
    font-family: ${theme.v3.font.family.brand};

    white-space: nowrap;

    &:hover {
      color: ${theme.v3.colors.brand.snappyBlue[60]};
    }
  `}
`;

export const AlertMessage = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.v3.font.weights.medium};
    white-space: nowrap;
  `}
`;


export const InfoLabel = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${theme.v3.colors.brand.snappyBlue[20]};
    font-family: ${theme.v3.font.family.brand};
    font-weight: ${theme.v3.font.weights.medium};
    font-size: 14px;
  `}
`;

export const ListRow = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoText = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.v3.font.weights.medium};
  `}
`;
